import React, { useEffect, useState } from "react";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";


const useDosageFormList = (
  onSelect,
  hideModal,
  selectParams,
  lookupType,
  selectModeParamData = null
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [paramsData, setParamsData] = useState({
    list: selectModeParamData?.list ?? "",
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { ADD_DOSAGE_FORM, DISPLAY_DOSAGE_FORM, MANAGE_FORMS } = ROUTE_PATHS;

  const screen_title = "Dosage Form List";
  const screenNumber = "RCDFL005";

  const formFields = [
    {
      fieldLabel: "DFL Dosage Form List",
      name: "list",
      label: "List",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  const dropdownOptions = [];

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        hideModal();
      },
      button_key: "F12",
    },
  ];

  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramData = selectParams.reduce((acc, key) => {
          if (rowData.hasOwnProperty(key["target"])) {
            acc[key["source"]] = rowData[key["target"]];
          }
          return acc;
        }, {});
        if (lookupType === "local") {
          onSelect(paramData);
        } else {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCDFL003I",
          parameters: {
            dflDosageFormList: rowData["list"],
            workInitialProgramMode: rowData["description"],
          },
        };
        console.log(message);
        window.top?.postMessage(message, "*");
      },
    },
    {
      label: "Forms",
      icon: <span className="material-icons">list</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCDLD001I",
          parameters: {
            dflDosageFormList: rowData["list"],
            dflDosageFormDescrip: rowData["description"],
          },
        };
        console.log(message);
        window.top?.postMessage(message, "*");
      },
    },
  ];

  const columnDef = [
    {
      header: "List",
      field: "list",
    },
    {
      header: "Description",
      field: "description",
    },
  ];

  const parmKey = "list";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcdflp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.fieldLabel + item.condition),
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteDosageForm = () => {
    if (selectedOption === "yes") {
      const params = { z2juhe: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/dosageformlist", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcdflp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteDosageForm,
    setSelectedOption,
    leftButtons,
  };
};

export default useDosageFormList;
